export default __webpack_public_path__ + "static/logo-05771722c25b257c52971d5243491863.png";